import React from 'react';

interface Props {
  className?: string;
}

export const WoytiLogo: React.FC<Props> = ({ className = 'h-11 w-11' }) => {
  return <img src="/assets/woyti-logo.svg" alt="" aria-hidden className={className} />;
};
